export function logicalInventoryName(item) {
  return item?.pack_name || item?.name || item?.item_name || item?.checklist_item_name || 'Equipo';
}

export function logicalInventoryKey(item) {
  const name = logicalInventoryName(item);

  if (item?.unconsolidated) return `unconsolidated:${item.id}`;
  if (item?.pack_id) return `pack:${item.pack_id}`;

  return `model:${name}::${item?.category || ''}::${item?.subcategory || ''}`;
}

// Fuera de Inventario el usuario opera modelos y cantidades. La colección
// `items` mantiene las unidades físicas para que los movimientos conserven
// trazabilidad sin exponer series, etiquetas ni códigos internos.
export function groupLogicalInventory(items) {
  const groups = new Map();

  for (const item of items || []) {
    const key = logicalInventoryKey(item);
    if (!groups.has(key)) {
      groups.set(key, {
        ...item,
        key,
        name: logicalInventoryName(item),
        items: [],
      });
    }
    groups.get(key).items.push(item);
  }

  return [...groups.values()];
}
